export const LanguageConstants = {
    // Language constants will go here.

}
